







import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class Burger extends Vue {
    @Prop() open!: boolean;
}
